import { createFileRoute } from '@tanstack/react-router'
import MarketingCampanhasDetalhePage from '@/pages/dashboard/marketing-campanhas-detalhe-page'
import { RequireModule } from '@/components/auth'
import { MODULES } from '@/constants/modules'

export const Route = createFileRoute(
  '/(dashboard)/dashboard/$dashboardId/marketing/campanhas-segmentadas/detalhe/$campanhaId',
)({
  component: function MarketingCampanhasDetalheRoute() {
    const { dashboardId } = Route.useParams()

    return (
      <RequireModule module={MODULES.MARKETING} dashboardId={dashboardId}>
        <MarketingCampanhasDetalhePage />
      </RequireModule>
    )
  },
})
